<template>
  <Form 
    :d_form='form'
    :d_model_tangki='model_tangki'
    v-if="id > 0 && load == 2"
  /> 

  
  <Form 
    :d_form='form'
    :d_model_tangki='model_tangki'
    v-else-if="id == 0 && load == 1"
  /> 
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tangki.daftar',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Daftar Tangki', route: '/tangki/daftar' },
      ],
      title : 'Daftar Tangki',
      form : {
        id : 0,
        tarikh : '',
        no_tangki : '',
        lkp_model_tangki_id : '',
        no_daftar_aset : '',
        kapasiti : '',
        bil_canister : '',
        tarikh_perolehan : '',
        nilai_perolehan : '',
        hantar: 0
        
      },
      tarikh : [],
      no_tangki : [],
      tangki_perolehan : [],
      no_daftar_aset : [],
      kapasiti : [],
      bil_canister : [],
      tarikh_perolehan : [],
      model_tangki : [],
      load : 0
      
      
    }
  },
  methods: {
    

  
 
     getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'tangki_daftar/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
   
  
  },
    
    getModel(){
          this.load = this.load + 1
          this.$zcomm.get(this.api_service + 'lookup/model_tangki', {}).then(res => {      
          this.model_tangki = res
        })
    },
  
  },

  watch: {

  },
  mounted() {
    this.getModel()
    this.getData()
    
  }
    
}
</script>
